export const CONNECT_WALLET = "connect_wallet";
export const DISCONNECT_WALLET = "disconnect_wallet";
export const TERMS_OF_SERVICES = "terms_of_services";

export const APPROVE_STAKING = "approve_staking";
export const APPROVE_UNSTAKING = "approve_unstaking";

export const STAKE_ENTERAMOUNT = "stake_enteramount";
export const MAX_STAKE = "max_stake";
export const STAKE_CTA = "stake_cta";
export const UNSTAKE_CTA = "unstake_cta";
export const STAKE_SUCCESSFUL = "stake_successful";
export const STAKE_FAILED = "stake_failed";
export const UNSTAKE_FAILED = "unstake_failed";

export const TOKENX_APPROVE_SUCCESSFUL = "tokenx_approve_successful";
export const TOKENX_APPROVE_FAILED = "tokenx_approve_failed";

export const TOKEN_APPROVE_SUCCESSFUL = "token_approve_successful";
export const TOKEN_APPROVE_FAILED = "token_approve_failed";

export const TOKEN_SELECTION = "token_selection";
export const ADD_RSETH = "add_rsETH";

export const CLICK_SUB_HEADER = "click_sub_header";
export const VIEW_ADDRESS_ON_SCANNER = "view_address_on_scanner";
export const COPY_ACCOUNT_ADDRESS = "copy_account_address";

export const WALLET_CONNECTED_SUCCESSFULLY = "wallet_connected_successfully";
